module.exports = __webpack_public_path__ + "static/lark-distillery-96039abb6da4c730f201e6d1ef086bb6.png";